import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { SystemNavBarComponent } from '@system/layout/nav-bar/system-nav-bar.component';
import { AuthService } from '@infra/auth/auth.service';

@Component({
  templateUrl: './internal-server-error.component.html',
  imports: [SystemNavBarComponent, TranslatePipe],
})
export class InternalServerErrorComponent {
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);

  goToDashboard(): void {
    if (this.authService.isCompanyChosen) {
      this.router.navigate([`/company/${this.authService.companyUrlName}`]);
    } else if (this.authService.isGlobalAdmin) {
      this.router.navigate(['/admin']);
    }
  }
}
